import {z} from 'zod';
import {
	editRemovesFromFilter,
	type EditRemovesFromFilterParams,
	getDefaultFilters,
	type GetDefaultFiltersParams,
	makeOptionalPropsNullable,
} from '@netx/core-next/schema';
import {
	AttributeVocabularyField,
	type IAttributeVocabulary,
	AttributeVocabularySchema,
} from './attributeVocabularySchema';

export const AttributeVocabularyFilterSchema = makeOptionalPropsNullable(
	AttributeVocabularySchema.partial().pick({
		[AttributeVocabularyField.name]: true,
	}),
);

export const AttributeVocabularyFilterableField =
	AttributeVocabularyFilterSchema.keyof().enum;

export const ATTRIBUTE_VOCABULARY_FILTERABLE_FIELDS = Object.values(
	AttributeVocabularyFilterableField,
);

export type AttributeVocabularyFilter = z.infer<
	typeof AttributeVocabularyFilterSchema
>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getAttributeVocabularyDefaultFilters = (
	params?: Omit<
		GetDefaultFiltersParams<AttributeVocabularyFilter>,
		'filterableFields'
	>,
): AttributeVocabularyFilter =>
	getDefaultFilters({
		...params,
		filterableFields: ATTRIBUTE_VOCABULARY_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const attributeVocabularyEditRemovesFromFilter = (
	params: Omit<
		EditRemovesFromFilterParams<
			IAttributeVocabulary,
			AttributeVocabularyFilter
		>,
		'schema'
	>,
) =>
	editRemovesFromFilter({
		...params,
		schema: AttributeVocabularySchema,
	});
